import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  input,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {cloneDeep, forEach, remove} from 'lodash';
import {OrderStatusColorValuesService} from '../../../../services/order-status-color-values.service';
import {AssetService} from '../../../../services/asset.service';
import {ConfirmationService, LazyLoadEvent} from 'primeng/api';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../../../../services/config.service';
import {DateFormatterService} from '../../../../services/dateformat';
import {CONSTANT} from '../../../../config/constant';
import {Actions, Subject} from '../../../../auth/rules';
import moment from 'moment-timezone';
import {NamingConventionFilterPipe} from '../../../../pipes/namingConvention.pipe';
import {AppMainComponent} from '../../../../app/core/main/app.main.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { filterGeoFencesForConsignment } from '../../../../state/Fleet/fleet.action';
import { Store } from '@ngrx/store';
import { AbilityService } from '../../../../services/ability.service';
import { CustomColumnFilterService } from '../../../../services/custom-column-filter.service';
const MMD_MODULE_NAME = CONSTANT.DMS_MODULES.MMD.MODULE;

@Component({
    selector: 'app-prime-table-row-expansion',
    templateUrl: './prime-table-row-expansion.component.html',
    styleUrls: ['./prime-table-row-expansion.component.scss'],
    standalone: false
})
export class PrimeTableRowExpansionComponent implements OnInit, OnChanges, OnDestroy {
    CONSTANT_LABEL = CONSTANT.DELIVERY_STATUS.LABELS;
  SUBJECT = Subject;
  ACTIONS = Actions;
  @Input() moduleName: any;
  @Input() orderTableHeaderArray: any = [];
  selectedCarriers: any = [];
  @Input() resetSelectedCarriers: number;
  @Input() carriersMultiSelectBtnConfig: any;
  @Input() orderTableHeaderObj: any = {};
  @Input() autoRefreshBtnConfig: AutoRefreshBtnConfig;
  @Input() sessionStorageName: string;
  @Input() groupedRoutePlansArray
  // @Input() allAssets: any = {};
  // @Input() modifiedData: any;

  // Row Expansion Header configurations
  @Input() autoOpen = false;
  @Input() autoOpenIndex = 1;
  @Input() rowTableHeaderArray: any = [];
  @Input() rowTableHeaderObj: any = {};
  @Input() rowTableData: any = [];
  @Input() rowTableVar: any = {};
  @Input() showHeaderIcons: HeaderIconsVisibility;
  @Input() showHeader: boolean;
  @Input() canEdit: any = {};
  @Input() autoOpenSidebar:boolean
  @Input() pageName: string = '';
  @Input() resetHighlightedId:number

  // Emitters
  @Output() sendClickedRowDataToMainComp: EventEmitter<any> = new EventEmitter();
  @Output() sendStopRoundTrip: EventEmitter<any> = new EventEmitter();
  @Output() sendReportDownloadToMainComp: EventEmitter<any> = new EventEmitter();
  @Output() sendIconClickedData: EventEmitter<any> = new EventEmitter();
  @Output() sendEditBtnClickedData: EventEmitter<any> = new EventEmitter();
  @Output() sendDataClickedToMakeAPICall: EventEmitter<any> = new EventEmitter();
  @Output() sendViewRouteBtnClicked: EventEmitter<any> = new EventEmitter();
  @Output() sendQrCodeBtnClicked: EventEmitter<any> = new EventEmitter();
  @Output() sendOdometerUpdateBtnClicked: EventEmitter<any> = new EventEmitter();
  @Output() sendRadioBtnClicked: EventEmitter<any> = new EventEmitter();
  @Output() sendLazyLoadedObject: EventEmitter<any> = new EventEmitter();
  @Output() sendEmptyLazyLoadedObjectStatus: EventEmitter<boolean> = new EventEmitter();
  @Output() sendAutoRefreshObject: EventEmitter<SentAutoRefreshObj> = new EventEmitter();
  @Output() sendSelectedRoutePlansIds: EventEmitter<string[]> = new EventEmitter();
  @Output() emittSelectedNonComplianceEvent: EventEmitter<any> = new EventEmitter();
  @Output() sendSelectedFieldsForFilter: EventEmitter<SelectedFieldsForFilter> = new EventEmitter();


  @ViewChild('timelineGrid') timelineGrid: ElementRef;

  showRoutePlansFilter:boolean

  disableDelStatusRadioBtn:boolean
  radioButtonsData

  agentDetails = {
    address: '',
    date: ''
  };
  deliveryPerson: any= [];
  timelineOuterContainerWidth: number;
  rowExpandedCount = 1;
  lazyLoadedObject: LazyLoadEvent;
 expandedRows:{[key: string]: boolean} = {};
 collapsedRows:any={};
  // order station radio butoon option holder
  selectedOption: any = null;
  _mmdModuleVar = {
    boxStatusLabel: 'Box Status',
    isMmdModule: false
  };

  seenOrderTableHeaderArray: any = [];
  selectedFilterPillsArray: any = [];
  isCustoToolTipSetting = false;
  stopRoundTripReason = 'Manually closing the trip.';
  odometer = {
    start: null,
    end: null,
    isOdometerStartNotPresent: false
  }
  onLoad = false;
  @Input() currentGroupById: string | null = '';
  @Input() getEtaDetailsForTimeline:Object

  @Input() highlightedOrderId: string = null;

  selectedRoutePlans;

  triggerUpdateLocationLinkDialog=signal<number>(0);
  copyLinkDialogInfo = signal<Record<string,any>>({
    header:'Tracking Link',
    subHeader:'Send tracking link to user.',
    openLinkText:'Click here to open the tracking link.',
    copyHeader:'Tracking Link',
    link:'',
    actionButtons:[{ label: 'Send', icon: 'pi pi-send', key: 'send' }],
    data:null,
    field:null
  });

  deliveryCompletionTypes = [
    { label: 'Delivered', value: 'delivered' },
    { label: 'Force Delivered', value: 'forceDelivered' },
    { label: 'Manually Completed', value: 'manuallyCompleted' },
    { label: 'Time Bound Completed', value: 'timeBoundCompleted' }
  ]
  returnTypes = [
    { label: 'Manually Returned', value: 'isManuallyReturned' },
    { label: 'Auto Returned', value: 'isAutoReturned' }
  ]
  showDeliveryCompletionTypesFilter = input<boolean>(false);
  showReturnTypesFilter = input<boolean>(false);
  selectedDeliveryCompletionTypes: string[];
  selectedReturnType: string = null;
  routePlansIds: string[];
  isCarriersChanged: boolean = false
  isDeliveryCompletionTypeChanged: boolean = false
  carrierFilterObj: SelectedCarrierValue;
  abilityService = inject(AbilityService)
  ability = this.abilityService.getAbilitiesChecker()
  routePlanPills = []
  constructor(public assetService: AssetService, public orderStatusColorService: OrderStatusColorValuesService,
              private confirmationService: ConfirmationService, private http: HttpClient, public configService: ConfigService,
              public dateFormatter: DateFormatterService,
              private appMain: AppMainComponent,private cd: ChangeDetectorRef,
              private translate: TranslateService,private store:Store) {

  }

  ngOnInit(): void {
    window.addEventListener('resize', this.refreshOrderedSeenOrderTableHeaderArray);
    this.showRoutePlansFilter= this.moduleName===MMD_MODULE_NAME
  }


  ngOnChanges(changes: SimpleChanges) {
    for (const propName of Object.keys(changes)) {
      const change = changes[propName];
      if (propName === 'rowTableData') {
        if (change.currentValue !== change.previousValue) {
          this.rowTableData.forEach((g)=> {
            g?.orderStatus?.options?.forEach((e)=>{
              if(e?.status === g?.orderStatus?.orderStatus){
                g.orderStatus['selectedOptions'] = e
              }
            })
          })
              // emitt event to open map sidebar of the first element of the data by default
            if (this.rowTableData.length > 0 && !this.onLoad) {
                if(this.autoOpenSidebar){
                  this.appMain.onMenuButtonClick(null)
                  this.sendViewRouteBtnClicked.emit(this.rowTableData[0]);
                  this.currentGroupById = this.rowTableData[0][this.rowTableVar['groupBy']]
                  this.onLoad = true
                }
            }

         this.expandSelectedRows()
          setTimeout(() => {
            this.timelineOuterContainerWidth = this.timelineGrid ? this.timelineGrid.nativeElement.offsetWidth : 200;
          }, 100)

        }
      }
      if (propName === 'orderTableHeaderObj') {
        if (change.currentValue !== change.previousValue) {
          if(this.moduleName && this.moduleName === MMD_MODULE_NAME) {
             this._mmdModuleVar.boxStatusLabel = 'Door Status';
             this._mmdModuleVar.isMmdModule = true;
          } else {
            this._mmdModuleVar.boxStatusLabel = 'Box Status';
             this._mmdModuleVar.isMmdModule = false;
          }

          if (this.orderTableHeaderArray.length !== Object.entries(this.orderTableHeaderObj).length) {
            const tArr = this.buildOrderTableHeaderArray();
            this.orderTableHeaderArray = tArr.filter(r => r !== null)
          }
          this.orderTableHeaderArray = this.translateTableHeaderArray(this.orderTableHeaderArray);

          setTimeout(() => {
            this.setDatesForFilterTypeDateRange();
          }, 100);
         setTimeout(() => {
          this.buildSelectedFilterPillsArray(this.lazyLoadedObject.filters);
         }, 1000)
         this.buildSeenOrderTableHeaderArray();
        }
      }
      if (propName === 'resetSelectedCarriers') {
        if (change.currentValue !== change.previousValue) {
         this.selectedCarriers = [];
         this.carriersChange();
        }
      }
      if (propName === 'groupedRoutePlansArray') {
        if (change.currentValue !== change.previousValue) {
          this.modifyRoutePlansArray()
        }
      }
      if (propName === 'resetHighlightedId') {
        if (change.currentValue !== change.previousValue) {
          this.currentGroupById = ''
        }
      }
      if (propName === 'carriersMultiSelectBtnConfig') {
        if (change.currentValue !== change.previousValue) {
          if (this.selectedCarriers && this.carriersMultiSelectBtnConfig) {
            this.selectedCarriers = this.selectedCarriers?.map(selectedCarrier => {
              return this.carriersMultiSelectBtnConfig.find(option => option.name === selectedCarrier.name);
            }).filter(carrier => carrier !== undefined);
          }
        }
      }
    }

  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.refreshOrderedSeenOrderTableHeaderArray);
  }
expandSelectedRows(){
    if(this.autoOpen || this.autoOpenIndex){
        forEach(this.rowTableData,(r, i:number)=> {
          const aI = this.autoOpenIndex - 1;
          this.rowTableData[i].index = i;
          const dId = r.deliveryId;
          const alreadyOpened = !this.expandedRows[dId] && this.autoOpen || aI === i && !this.collapsedRows[dId];
          if (alreadyOpened) {
            this.expandedRows[dId] = this.autoOpen || aI === i;
            const size = Object.keys(this.expandedRows).length;
            this.rowExpandedCount = size;
          }
        })
    }
}

buildOrderTableHeaderArray() {
  return Object.values(this.orderTableHeaderObj)?.map(o => {
    if (o['filterFieldName']) {
      return {
        isColumnSeen: o['isColumnSeen'] ? o['isColumnSeen'] : false,
        field: o['filterFieldName'],
        header: o['columnDisplayName']
      };
    } else {
      return null;
    }
  });
}

  getOrderedColumnSeenArray() {
    const orderedColumnSeenArray = [];
    for (let i = 0; i < this.orderTableHeaderArray.length; i++) {
      if (
        this.orderTableHeaderObj[this.orderTableHeaderArray[i]['field']][
          'isColumnSeen'
          ]
      ) {
        orderedColumnSeenArray.push(this.orderTableHeaderArray[i]);
      }
    }
    return orderedColumnSeenArray;
  }

  buildSelectedCarrierFilterPillsArray(arr) {
    forEach(arr, (value) => {
      const pillObj = {
        label: '',
        tooltip: '',
        key: '',
        removeAction: true,
        filterType:''
      };
      if (value) {
        pillObj.label = value.name ?? null;
        pillObj.key = value._id ?? null;
        pillObj.tooltip = 'Carrier';
        pillObj.filterType = 'carrier';
        this.selectedFilterPillsArray.push(pillObj);
      }
    })
  }

  buildSelectedDeliveryCompletionTypesFilterPillsArray(arr){
    forEach(arr, (value) => {
      console.log(value)
      const type = this.deliveryCompletionTypes.find(type => type.value === value)
      const pillObj = {
        label: '',
        tooltip: '',
        key: '',
        removeAction: true,
        filterType:''
      };
      if (type) {
        pillObj.label = type.label ?? null;
        pillObj.key = type.value ?? null;
        pillObj.tooltip = 'Delivery Completion Type';
        pillObj.filterType = 'deliveryCompletionType';
        this.selectedFilterPillsArray.push(pillObj);
      }
    })
  }

  buildSelectedReturnType(selectedReturnType){
    const type = this.returnTypes.find(type => type.value === selectedReturnType)
    const pillObj = {
      label: '',
      tooltip: '',
      key: '',
      removeAction: true,
      filterType:''
    };
    if (type) {
      pillObj.label = type.label ?? null;
      pillObj.key = type.value ?? null;
      pillObj.tooltip = 'Return Type';
      pillObj.filterType = 'returnType';
      this.selectedFilterPillsArray.push(pillObj);
    }
  }

  buildSelectedRoutePlans(routePlanPills){
    forEach(routePlanPills, (obj) => {
      const pillObj = {
        label: '',
        tooltip: '',
        key: '',
        removeAction: true,
        filterType:''
      }
      pillObj.label = obj.label ? obj.label : null;
      pillObj.key = obj.filterParameterValue ?? null;
      pillObj.tooltip = 'TD / Route Plan';
      pillObj.filterType = 'routePlan';
      this.selectedFilterPillsArray.push(pillObj);
    });
  }

  buildSelectedFilterPillsArray(filters){
    const filterPipe = new NamingConventionFilterPipe();
    this.selectedFilterPillsArray = [];
    this.buildSelectedCarrierFilterPillsArray(this.selectedCarriers) ;
    this.buildSelectedDeliveryCompletionTypesFilterPillsArray(this.selectedDeliveryCompletionTypes) ;
    this.buildSelectedReturnType(this.selectedReturnType) ;
    this.buildSelectedRoutePlans(this.routePlanPills);
    forEach(filters, (value, key) => {
      const firstObj = value[0];
      switch (firstObj.matchMode) {
        case 'singleSelectFromOptions':
          if (firstObj.value) {
            const pillObj = {
              filterParameterValue: '',
              label: '',
              tooltip: '',
              key: '',
              removeAction: true
            };
            pillObj.filterParameterValue = firstObj.value.filterParameterValue ? firstObj.value.filterParameterValue : null;
            pillObj.label = firstObj.value.name ? firstObj.value.name : null;
            pillObj.key = key;
            pillObj.tooltip = filterPipe.transform(key);
            this.selectedFilterPillsArray.push(pillObj);
          }
          break;
        case 'multiSelectFromOptions':
          forEach(firstObj.value, (obj) => {
            const pillObj = {
              filterParameterValue: '',
              label: '',
              tooltip: '',
              key: '',
              removeAction: true
            };
            pillObj.filterParameterValue = obj.filterParameterValue ? obj.filterParameterValue : null;
            pillObj.label = obj.name ? obj.name : null;
            pillObj.key = key;
            pillObj.tooltip = filterPipe.transform(key);
            this.selectedFilterPillsArray.push(pillObj);
          });
          break;
        case 'groupedMultiSelectFromOptions':
          forEach(firstObj.value,(obj) => {
            const pillObj = {
              filterParameterValue: '',
              label: '',
              tooltip: '',
              key: '',
              removeAction: true
            };
            pillObj.filterParameterValue = obj.filterParameterValue ? obj.filterParameterValue : null;
            pillObj.label = obj.name ? obj.name : null;
            pillObj.key = key;
            pillObj.tooltip = filterPipe.transform(key);
            this.selectedFilterPillsArray.push(pillObj);
          });
          break;
        case 'dateRange':
          if (firstObj.value && firstObj.value.length > 1) {
            const pillObj = {
              filterParameterValue: '',
              label: '',
              tooltip: '',
              key: '',
              removeAction: false
            };
            pillObj.filterParameterValue = firstObj.value[0].filterParameterValue ? firstObj.value[0].filterParameterValue : null;
            let locLabel = '';
            locLabel = moment(firstObj.value[0]).format('DD-MM-YY') + ' - ' + moment(firstObj.value[1]).format('DD-MM-YY');
            pillObj.label = locLabel ? locLabel : null;
            pillObj.key = key;
            pillObj.tooltip = filterPipe.transform(key);
            this.selectedFilterPillsArray.push(pillObj);

          }
          break;
          default:
          break;
      }
    });
  }

  buildSeenOrderTableHeaderArray() {
    this.orderTableHeaderArray = this.translateTableHeaderArray(this.orderTableHeaderArray)
    const sessionColumnDropdownName = this.sessionStorageName + '_columnDropdown';
     if (sessionStorage.getItem(sessionColumnDropdownName)) {
       this.seenOrderTableHeaderArray = cloneDeep(JSON.parse(sessionStorage.getItem(sessionColumnDropdownName)));
       this.refreshOrderedSeenOrderTableHeaderArray('e');
       return;
    }

    forEach(this.orderTableHeaderArray, (value) => {
      if(value.isColumnSeen) {
        this.seenOrderTableHeaderArray.push(value);
      }
    });

    if (this.sessionStorageName) {
      sessionStorage.setItem(sessionColumnDropdownName, (JSON.stringify(this.seenOrderTableHeaderArray)));
    }
  }

  refreshOrderedSeenOrderTableHeaderArray(_) {
    const sessionColumnDropdownName = this.sessionStorageName + '_columnDropdown';
    const dictOfSeenOrderTableHeaderArrayFieldNames = {};
    forEach(this.seenOrderTableHeaderArray, (_, index) => {
      dictOfSeenOrderTableHeaderArrayFieldNames[this.seenOrderTableHeaderArray[index]['field']] = true;
    });

      forEach(this.orderTableHeaderArray, (_, index) => {
        if (this.orderTableHeaderArray[index]['field'] in dictOfSeenOrderTableHeaderArrayFieldNames) {
            this.orderTableHeaderObj={...this.orderTableHeaderObj,
              [this.orderTableHeaderArray[index]['field']]:{
                ...this.orderTableHeaderObj[this.orderTableHeaderArray[index]['field']],
                isColumnSeen:true
              }}
        } else {
          this.orderTableHeaderObj={...this.orderTableHeaderObj,
            [this.orderTableHeaderArray[index]['field']]:{
              ...this.orderTableHeaderObj[this.orderTableHeaderArray[index]['field']],
              isColumnSeen:false
            }}
        }
      });

    if (this.sessionStorageName) {
      sessionStorage.setItem(sessionColumnDropdownName, (JSON.stringify(this.seenOrderTableHeaderArray)));
    }
  }

  getRowColumnSeenArray() {
    const rowColumnSeenArray = [];
    for (let i = 0; i < this.rowTableHeaderArray.length; i++) {
      if (
        this.rowTableHeaderObj[this.rowTableHeaderArray[i]['field']][
          'isColumnSeen'
          ]
      ) {
        rowColumnSeenArray.push(this.rowTableHeaderArray[i]);
      }
    }
    return rowColumnSeenArray;
  }

 

  confirm(event: Event, data, field) {
    switch (field) {
      case 'customerTrack':
        this.createCustomerLinkMsg(event, data, field);
        break;
      case 'removeOrderAssignment':
        let orderId = '';
        let popupMessage = '';
        if (data.orderId) {
          orderId = data.orderId;
          popupMessage = 'Do you want to remove the order ' + orderId + ' from assignment ?';
        }
        if (data.orderId && data.orderId === CONSTANT.DELIVERY_STATUS.LABELS.RETURNING_TO) {
          popupMessage = 'Do you want to complete the round trip ?';
        }
        this.confirmationService.confirm({
          target: event.target,
          message: popupMessage,
          icon: 'pi pi-info-circle',
          key: 'tableRowExpConfitmPopup',
          accept: () => {
            //confirm action
            this.emitIconClickedData(data, field);
          },
          reject: () => {
            //reject action
          }
        });
        break;
      default:
        break;
    }
  }

  pillRemoved(pill) {
    console.log(pill)
    if(pill?.filterType){
     switch(pill?.filterType){
      case 'carrier':
        this.selectedCarriers = this.selectedCarriers.filter(value => value?._id !== pill?.key)
        this.isCarriersChanged = true;
        this.carriersChange(true)
        break;
      case 'deliveryCompletionType':
        this.selectedDeliveryCompletionTypes = this.selectedDeliveryCompletionTypes.filter(value => value !== pill?.key)
        this.isDeliveryCompletionTypeChanged = true;
        this.deliveryCompletionTypesChange()
        break;
      case 'returnType':
        this.selectedReturnType = null
        this.returnTypesChange()
        break;
      case 'routePlan':
       if(Array.isArray(pill?.key)){
        const keyValues = pill?.key.map(k => k.filterParameterValue);
        this.selectedRoutePlans = this.selectedRoutePlans.filter(item => {
            return !keyValues.includes(item.filterParameterValue);
        });
        this.selectedRoutePlans = this.selectedRoutePlans.filter(value => value?.label !== pill?.label)
       } else {
        this.selectedRoutePlans = this.selectedRoutePlans.filter(value => value?.filterParameterValue !== pill?.key)
       }
        this.filterByRoutePlans(this.selectedRoutePlans, true);
        break;
       default:
        break
     }

    } else {
      this.lazyLoadedObject.filters = (this.removeFilterManually(pill, this.lazyLoadedObject.filters));

    const sessionStoredData = JSON.parse(sessionStorage.getItem(this.sessionStorageName));
    if (sessionStoredData && sessionStoredData['filters']) {
      sessionStoredData['filters'] = (this.removeFilterManually(pill, sessionStoredData['filters']));
      sessionStorage.setItem(this.sessionStorageName, (JSON.stringify(sessionStoredData)));
    }

    this.sendLazyLoadedObject.emit(this.lazyLoadedObject)
    this.handleColumnFilterClass(this.lazyLoadedObject)
  }
}

  removeFilterManually(pill, filters){
    const selctedFieldToRemove = filters[pill.key][0];
    switch (selctedFieldToRemove.matchMode) {
      case 'singleSelectFromOptions':
        if (selctedFieldToRemove.value.filterParameterValue === pill.filterParameterValue) {
          selctedFieldToRemove.value = null;
        }
        break;
      case 'multiSelectFromOptions':
        remove(selctedFieldToRemove.value, function(n: any) {
          return (n.filterParameterValue === pill.filterParameterValue);
        });
        break;
      case 'groupedMultiSelectFromOptions':
        remove(selctedFieldToRemove.value, function(n: any) {
          return (n.filterParameterValue === pill.filterParameterValue);
        });
        break;
      default:
      break;
    }

    return filters;
  }

  clickableDataIsClicked(data) {
    this.currentGroupById = data[this.rowTableVar['groupBy']]
    this.highlightedOrderId = data?.orderId
    this.sendClickedRowDataToMainComp.emit(data);
  }

  emitIconClickedData(data, field){
    data['iconFieldName'] = field
    this.sendIconClickedData.emit(data)
  }

  // emitDataToDelete(data){
  //   this.sendDataToDelete.emit(data)
  // }
  dataClickedToMakeApiCall(data){
    this.sendDataClickedToMakeAPICall.emit(data)
  }

  editBtnClicked(data){
    this.sendEditBtnClickedData.emit(data);
  }
  viewRouteBtnClicked(data,status){
    data.openComplianceEventsDialogNumber = (!!status ? (Math.random()) : (-1*Math.random()));

    this.currentGroupById = data[this.rowTableVar['groupBy']];
    this.highlightedOrderId = null;
    this.store.dispatch(filterGeoFencesForConsignment({consignmentId:data[this.rowTableVar['groupBy']]}))
    this.sendViewRouteBtnClicked.emit(data);
  }
  viewQrCodeBtnClicked(data){
    this.sendQrCodeBtnClicked.emit(data);
  }
  downloadReport(data,format){
    data['format'] = format;
    this.sendReportDownloadToMainComp.emit(data);
  }
  isItemString(item){
    if(typeof item === 'string'){
      return true;
    }
    return false;
  }
  isItemObject(item){
    if(item instanceof Object){
      return true;
    }
    return false;
  }


  handleData(event,expansionData){
    const ed = expansionData
    ed.openComplianceEventsDialogNumber = Math.random();
    this.emittSelectedNonComplianceEvent.emit({
      event,expansionData:ed
    })
  }

  onRowExpand(e){
    const dId = e.data.deliveryId;
    this.collapsedRows[dId] = false;
    ++this.rowExpandedCount;
  }


  onRowCollapse(_) {
    // const dId = e.data.deliveryId;
    --this.rowExpandedCount;
    // this.collapsedRows[dId] = true;
    if (this.rowExpandedCount === 0 && !this.showHeader) {
       this.showHeader = false;
    }
  }

  toggleRowExapnsion(rowIdToToggle:string){
    if(this.collapsedRows[rowIdToToggle]){
      this.collapsedRows[rowIdToToggle] = false;
    }else{
      this.collapsedRows[rowIdToToggle] = true;
    }
  }

  orderStatusStyle(status, field){
    const styleObj = this.orderStatusColorService.getTextAndBorderColor(status, field);
    styleObj['border-radius'] = '16px';
    styleObj['background-color'] = 'transparent';

    return styleObj

  }
  onRadioBtnClick(status, rowData){
    this.sendRadioBtnClicked.emit({status: status, id:rowData.id});
    this.selectedOption = null;
  }

  loadItems(event: LazyLoadEvent) {
    this.lazyLoadedObject = event;
    const date = this.lazyLoadedObject?.filters?.expectedDeliveryDateTimeDetails?.[0]?.value
    this.buildSelectedFilterPillsArray(this.lazyLoadedObject.filters);
    if (this.checkIfStartDateAndEndDatePresent()) {
      this.sendLazyLoadedObject.emit(this.lazyLoadedObject)
    } else if(!date?.includes(null)){
      this.sendEmptyLazyLoadedObjectStatus.emit(true)
    }
    this.handleColumnFilterClass(this.lazyLoadedObject)
 }

  setDatesForFilterTypeDateRange(){
    forEach(this.orderTableHeaderObj, (value, key) => {
      const fType = value && value.filterMenuType;
      if ( fType && fType === 'dateRange') {
      if(this.lazyLoadedObject['filters'][key]){
        if (!this.lazyLoadedObject['filters'][key][0]['value']) {
          this.lazyLoadedObject['filters'][key][0]['value'] = [];
        }
        this.lazyLoadedObject['filters'][key][0]['value'].push(value.startDate);
        this.lazyLoadedObject['filters'][key][0]['value'].push(value.endDate);
      }
      }
    });
  }


  checkIfStartDateAndEndDatePresent() {
    let isPresent = true;
    forEach(this.orderTableHeaderObj, (value, key) => {
      const fType = value.filterMenuType && value.filterMenuType;
      if ( fType === 'dateRange') {
      if(this.lazyLoadedObject['filters'][key] && Array.isArray(this.lazyLoadedObject['filters'][key]) && this.lazyLoadedObject['filters'][key][0]['value'] && this.lazyLoadedObject['filters'][key][0]['value'].length > 1
      && this.lazyLoadedObject['filters'][key][0]['value'][0] && this.lazyLoadedObject['filters'][key][0]['value'][1] !== null){
        isPresent = true;
      } else {
        isPresent = false;
      }
      }
    });
    return isPresent;
  }

  getAssetLocation(e) {
    this.agentDetails.address = '';
    this.agentDetails.date = '';
    if(e.agentId) {
      this.assetService.geoEncodedAssetLocation(e.agentId).subscribe((data: any) => {
        if (data && data.address) {
          this.agentDetails.address = data.address;
          if (data && data.date) {
            this.agentDetails.date = this.dateFormatter.convertDateToSelectedTimezone(data.date);
          }
        } else {
          this.agentDetails.address = 'No Address Found';
        }
      }, () => {
        this.agentDetails.address = 'No Address Found';
      })
    }
  }

  createCustomerLinkMsg(_, data, field) {
    if (data.id) {
      this.getCustomerTrackLink(data.id).subscribe((res: any) => {
        if (!res?.url) return;

        const copyLinkDialogInfo = this.copyLinkDialogInfo();

        copyLinkDialogInfo.link = res?.url;
        copyLinkDialogInfo.data = data;
        copyLinkDialogInfo.field = field;
        copyLinkDialogInfo.header = data?.orderId ? 'Tracking Link For ' + data?.orderId : 'Tracking Link';

        this.copyLinkDialogInfo.set(copyLinkDialogInfo)
        
        this.triggerUpdateLocationLinkDialog.set(Math.random());
      })
    }
  }

 

  getCustomerTrackLink(id) {
    return this.http.get(this.configService.appConfig.appBaseUrl + 'deliveryManagement/management/customerLink/' + id);
  }

  showFilterPills:boolean
  showSelectButton:boolean

  carriersChange(isEmitFiltersNeeded: boolean = true) {
    const slectedValues: SelectedCarrier[] = [];
    forEach(this.selectedCarriers, function(value) {
      const obj: SelectedCarrier = {
        filterParameterValue: null,
        name: null
      };
      value._id ? obj.filterParameterValue = value._id : obj.filterParameterValue = null ;
      value.name ? obj.name = value.name : obj.name = null;
      slectedValues.push(obj);
    });

    const carrierFilterObj: SelectedCarrierValue = {
      value: slectedValues
    };
    this.carrierFilterObj = { ...carrierFilterObj };
    if (isEmitFiltersNeeded && this.isCarriersChanged) {
      this.emitSelectedFieldsForFilter();
    }
    this.buildSelectedFilterPillsArray(this.lazyLoadedObject.filters)
    this.isCarriersChanged = false;
  }

  canUpdateState() {
    let canCreate: boolean;
    canCreate = false;
    if(this.moduleName === MMD_MODULE_NAME){
      if ( this.ability.can( Actions.READ, Subject.MMD_MANAGEMENT)) {
        if (this.ability.can( Actions.WRITE, Subject.MMD_MANAGEMENT)) {
          canCreate = true;
        }
      }
    } else {
      if ( this.ability.can( Actions.READ, Subject.LMD_MANAGEMENT)) {
        if (this.ability.can( Actions.WRITE, Subject.LMD_MANAGEMENT)) {
          canCreate = true;
        }
      }
    }
    return canCreate;
  }

  checkIfValueIsNotRoundTripLabel(value) {
    const satus = true;
    if (value === CONSTANT.DELIVERY_STATUS.LABELS.RETURNING_TO
      || value === CONSTANT.DELIVERY_STATUS.LABELS.ROUNDTRIP ||
      value === CONSTANT.DELIVERY_STATUS.LABELS.RETURNED) {
      return false;
    }
    return satus;
  }

  cancelTrip(data) {
    const carrierDetails = {
      ...data?.carrierDetails,
      odometer: {
        ...data?.carrierDetails?.odometer,
        start: this.odometer.start,
        end: this.odometer.end
      }
    };

    let cancelObj = {
      'id': data?.deliveryId,
      'reason': this.stopRoundTripReason
    };
    if(this.odometer.end){
        cancelObj['carrierDetails'] = carrierDetails
    }
     this.sendStopRoundTrip.emit(cancelObj);
  }


  customRadiotButtonClicked(data) {
    this.emitIconClickedData(data, 'removeOrderAssignment');
  }

  // private canEditByDeliveryId(dId: string) {
  //   const that = this;
  //   this.dmsAssignmentService.checkCanEditOrderStatus(dId).subscribe(async (data) => {
  //     that.canEdit[dId] = data?.['canEdit'];
  //   });
  // }

  getAddCarrInfo(data){
    let result=[]
    data && Object.keys(data)?.forEach(val=>{
      data[val] && result.push({'label':val,'value':data[val]})
    })
    return result
  }

  //TODO: need to confirm about this method
  setup(a,b){
    if(a&&b){

    }
  }

  translateTableHeaderArray(arr){
    const translate = new TranslatePipe(this.translate, this.cd);
    let localArr = [...arr];
    localArr.forEach((value,idx)=>{
      let localVal = {...value}
      let label = translate.transform(localVal['header'])
      localVal['header'] = label
      localVal['uId'] = idx
      localArr[idx] = {...localVal}
    })
    return localArr
  }

  showTempTooltip(expansionData){
    let str = 'Temperature';
    if (expansionData.temp && expansionData?.sensorLastUpdated)
    str = str + ' updated : ' + expansionData?.sensorLastUpdated;
    return str;
  }

  latestTime(expansionData){
    return expansionData?.sensorLastUpdated || '';
  }

  showTooltip(filterFieldName, data){
     let tT = '';
     switch (filterFieldName) {
      case "tempDetails":
        tT = data?.tempDetailsTooltip ?? ''
        break;
      case "orderStatus":
         if (data?.orderId === CONSTANT.DELIVERY_STATUS.LABELS.RETURNED) {
          tT = 'Trigger Type'
        }
        break;
      default:
        break;
    }
     return tT;
  }

  autoRefreshToggle(_){
    const obj: SentAutoRefreshObj = {
     checked: this.autoRefreshBtnConfig.checked,
     isNewDataToLoadReq: this.autoRefreshBtnConfig.checked ?? false
    }

    if (this.sessionStorageName) {
      const sessionARName = this.sessionStorageName + '_autoRefresh'
      sessionStorage.setItem(sessionARName, (this.autoRefreshBtnConfig.checked).toString());
    }

    this.sendAutoRefreshObject.emit(obj);
   }

  autoRefreshBtnClicked() {
     const obj: SentAutoRefreshObj = {
       checked: this.autoRefreshBtnConfig.checked,
       isNewDataToLoadReq: true
      }
     this.sendAutoRefreshObject.emit(obj);
   }

   alertNotificationBtnClicked(){
    const obj: SentAutoRefreshObj = {
      checked: false,
      isNewDataToLoadReq: false,
      isAlertNotificationBtn: true,
     }
    this.sendAutoRefreshObject.emit(obj);
   }

   modifyRoutePlansArray(){
     this.groupedRoutePlansArray = this.groupedRoutePlansArray?.map((rPlanGrp, pIdx) => {

       const grpChildren = rPlanGrp?.children?.map((rPlanChild, cIdx) => {
         return { ...rPlanChild, key: pIdx + cIdx + Math.random() }
      })
       return { ...rPlanGrp, children: grpChildren, key: pIdx + Math.random() }
    })
   }

   manageFilterPanelHeight:boolean

  filterByRoutePlans(rPlans, isEmitFiltersNeeded: boolean = true) {
    const modData= []
    const groupRPlanCount = {}
    rPlans?.forEach(rPlan=>{
      groupRPlanCount[rPlan.parentName] = groupRPlanCount[rPlan.parentName] ? (groupRPlanCount[rPlan.parentName]+1) : 1
      rPlan?.filterParameterValue &&
        modData.push({...rPlan,parent: { ...(rPlan.parent || {}), children: [] }});
    })
    this.routePlanPills = modData

    this.groupedRoutePlansArray?.forEach((groupRPlan) => {
      if(groupRPlan?.children?.length === groupRPlanCount?.[groupRPlan?.label]){
       this.routePlanPills = this.routePlanPills.filter(pill=>pill.parentName !== groupRPlan.label)
       this.routePlanPills.push({...groupRPlan,filterParameterValue:groupRPlan?.children || []})
      }
      });

    const rPlansIds= []
    rPlans?.forEach(r=>{

      r?.filterParameterValue &&
      rPlansIds.push(r.filterParameterValue)

    })
    this.routePlansIds = [...rPlansIds];

    this.buildSelectedFilterPillsArray(this.lazyLoadedObject.filters)
    if (isEmitFiltersNeeded)
      this.emitSelectedFieldsForFilter();
   }

   clearFilters() {
    this.selectedRoutePlans = [];
    this.selectedCarriers = [];
    this.selectedDeliveryCompletionTypes = [];
    this.selectedReturnType = null;
    this.filterByRoutePlans(this.selectedRoutePlans, false);
    this.carriersChange(false)
    this.emitSelectedFieldsForFilter();
  }

  deliveryCompletionTypesChange() {
    this.buildSelectedFilterPillsArray(this.lazyLoadedObject.filters)
    if (this.isDeliveryCompletionTypeChanged) {
      this.emitSelectedFieldsForFilter();
    }
    this.isDeliveryCompletionTypeChanged = false;
  }

  returnTypesChange(){
    this.buildSelectedFilterPillsArray(this.lazyLoadedObject.filters)
    this.emitSelectedFieldsForFilter();
  }

  emitSelectedFieldsForFilter() {
    const selectedFieldsForFilterObj: SelectedFieldsForFilter = {
      selectedCarriers: this.carrierFilterObj,
      selectedRoutePlans: this.routePlansIds,
      selectedDeliveryCompletionTypes: this.selectedDeliveryCompletionTypes,
      selectedReturnType: this.selectedReturnType
    }
    this.sendSelectedFieldsForFilter.emit(selectedFieldsForFilterObj)
  }

  appliedColumnFilterFields = signal<Record<string, boolean>>({})
  customColumnFilterService = inject(CustomColumnFilterService)

  handleColumnFilterClass(e){
    const tableFilters = e?.filters || {};
    const appliedColumnFilterFields = this.appliedColumnFilterFields()
    this.appliedColumnFilterFields.set(this.customColumnFilterService.handleColumnFilterClass(tableFilters,appliedColumnFilterFields))
  }
  updateOdometerValues(data){
    this.sendOdometerUpdateBtnClicked.emit(data)
  }

  setOdometerReadings(data){
     this.odometer.end = null
     this.odometer.start = data?.carrierDetails?.odometer?.start
     this.odometer.isOdometerStartNotPresent = false;
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.charCode;
  
    // Allow only digits (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  checkIfOdometerStartPresent(){
    if(this.odometer.end){
      if(this.odometer.start) {
        this.odometer.isOdometerStartNotPresent = false;
      } else {
        this.odometer.isOdometerStartNotPresent = true;
      }
    } else {
      this.odometer.isOdometerStartNotPresent = false;
    }
  }

}


export interface HeaderIconsVisibility {
  humidity: boolean;
  temp: boolean;
  boxStatus: boolean;
  view: boolean;
  edit: boolean;
  address: boolean;
  report: boolean;
  forceStopRoundTrip?: boolean;
  showComplianceEvents?: boolean;
  qrCode: boolean;
  lastUpdated: boolean;
  editOdometerReading: boolean
}

export interface AutoRefreshBtnConfig {
  checked: boolean;
  showRefreshIcon: boolean;
  showEnableBtn: boolean;
  newConsignmentCount: number;
  showAlertNotificationBtn?: boolean
}

export interface SentAutoRefreshObj {
  checked: boolean;
  isNewDataToLoadReq: boolean;
  isAlertNotificationBtn?: boolean;
}

export interface SelectedDeliveryAndReturnTypes {
  selectedDeliveryCompletionTypes: string[]
  selectedReturnType: string
}

export interface SelectedFieldsForFilter {
  selectedRoutePlans: string[]
  selectedCarriers: SelectedCarrierValue
  selectedDeliveryCompletionTypes: string[]
  selectedReturnType: string
}

export interface SelectedCarrierValue {
  value: SelectedCarrier[]
}
export interface SelectedCarrier {
  filterParameterValue: string,
  name: string
}
